import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import ReviewQueue from './pages/ReviewQueue'
import Validate from './pages/Validate'
import Layout from './components/Layout'

const mockSession = { user: { email: 'jsnhrpr@gmail.com' } }

export default function App() {
  return (
    <Layout session={mockSession}>
      <Routes>
        <Route path="/" element={<Dashboard session={mockSession} />} />
        <Route path="/review" element={<ReviewQueue session={mockSession} />} />
        <Route path="/validate" element={<Validate session={mockSession} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  )
}
